export default {
  activity: 'activity',
  booking: 'booking',
  competency: 'competency',
  template: 'template',
  user: 'user',
  userleave: 'userleave',
  assignment: 'assignment',
  rosterbuilder: 'rosterbuilder'
};
